import { useMutation } from 'react-query';

import { useCompany } from 'modules/app/hooks/useCompany';
import { postV2ApiCompanyIdRequestsDraftsSubmits } from 'src/client/spendesk-api';

export const useBulkSubmitDraftsMutation = () => {
  const company = useCompany();
  return useMutation(
    ['v2', 'requests', 'drafts', 'bulkSubmit'],
    async (requestIds: string[]) => {
      const response = await postV2ApiCompanyIdRequestsDraftsSubmits({
        path: {
          companyId: company.id,
        },
        body: {
          requestIds,
        },
      });

      if (response.statusCode !== 200) {
        throw new Error('Failed to submit requests');
      }
      return response.body;
    },
    {
      retry: false,
    },
  );
};
